<pui-sub-header>
  <div class="d-flex w-100 justify-content-between align-items-center">
    <div>
      <button pui-button variant="secondary" (click)="onGoBack()"><pui-icon left icon="arrow-left" />Powrót</button>
    </div>
    <div>Powiąż konto</div>
    <div class="d-flex gap-12">
      <button pui-button variant="primary" (click)="onSubmit()">Powiąż konto</button>
    </div>
  </div>
</pui-sub-header>

<div class="page-container">
  <pui-table2 [dataSource]="filteredUsers()" [trackBy]="trackBy" [sortBy]="sort().key"
    [sortDirection]="sort().direction">
    <ng-container header>
      <form class="d-flex align-items-center gap-16 justify-content-between w-100" [formGroup]="filtersForm">
        <pui-form-field>
          <pui-label>Wyszukaj</pui-label>
          <pui-icon icon="search-md" left />
          <input puiInput placeholder="Wyszukaj" formControlName="global" />
        </pui-form-field>
        <pui-divider orientation="vertical" />
        <pui-form-field>
          <pui-label>Typ</pui-label>
          <pui-select [multiple]="false" formControlName="group">
            <pui-placeholder>Typ</pui-placeholder>
            <pui-option [value]="">Wszystkie</pui-option>
            @for(option of groupTypeOptions; track $index){
            <pui-option [value]="option">{{option}}</pui-option>
            }
          </pui-select>
        </pui-form-field>
      </form>
    </ng-container>
    <ng-template #header>
      <th>
        <pui-checkbox [triState]="true" [value]="allSelected() ? true : (someSelected() ? null : false)"
          (changed)="toggleAll()" />
      </th>
      <th>Użytkownik</th>
      <th>Imię</th>
      <th>Nazwisko</th>
      <th>Organizacja</th>
      <th>Jednostka</th>
      <th>Typ</th>
      <th>Rola</th>
    </ng-template>
    <ng-template #row let-row>
      <tr>
        <td><pui-checkbox [value]="isSelected(row)" (changed)="toggleUser(row)" /></td>
        <td>{{row.username}}</td>
        <td>{{row.firstName}}</td>
        <td>{{row.lastName}}</td>
        <td>{{row.organization}}</td>
        <td>{{row.responsibleUnit}}</td>
        <td><pui-badge [variant]="row.group | groupColor">{{row.group}}</pui-badge></td>
        <td>{{row.role}}</td>
      </tr>
    </ng-template>
  </pui-table2>
</div>